import { schema } from "normalizr";
import { regionSchema } from "../region";

export const frameSchema = new schema.Entity("frames", {
  regions: [regionSchema]
});
